import { render } from "./BookDetails.vue?vue&type=template&id=f1eaa2cc&scoped=true"
import script from "./BookDetails.vue?vue&type=script&lang=js"
export * from "./BookDetails.vue?vue&type=script&lang=js"

import "./BookDetails.vue?vue&type=style&index=0&id=f1eaa2cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1eaa2cc"]])

export default __exports__